import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', path: '/' },
    { label: '国漫', path: '/category/guoman' },
    { label: '日漫', path: '/category/riman' },
    { label: '韩漫', path: '/category/hanman' },
    { label: '热门推荐', path: '/category/hot' },
    { label: '最新更新', path: '/category/latest' },
  ],
  categories: [
    { label: '玄幻', path: '/category/guoman' },
    { label: '热血', path: '/category/guoman' },
    { label: '恋爱', path: '/category/hanman' },
    { label: '校园', path: '/category/riman' },
    { label: '古风', path: '/category/guoman' },
    { label: '奇幻', path: '/category/hanman' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
    { label: '版权声明', path: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 tracking-wide">
                琉璃漫站
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              琉璃漫站是专注于正版漫画在线阅读的综合平台，汇聚海量国漫、日漫、韩漫资源，提供高清流畅的阅读体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 space-y-2">
              <p className="text-sm text-background-50/60 flex items-center gap-2">
                <i className="ri-mail-line"></i>
                contact@liulicomic.com
              </p>
              <p className="text-sm text-background-50/60 flex items-center gap-2">
                <i className="ri-phone-line"></i>
                400-888-6666
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-50/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-50/40">
            &copy; 2026 琉璃漫站 LiuliComic. All rights reserved.
          </p>
          <p className="text-sm text-background-50/40">
            备案号：京ICP备20260808001号
          </p>
        </div>
      </div>
    </footer>
  );
}